import type { PortableTextBlock } from '@portabletext/react';

import type { PageBuilderSimpleBlockContent } from '@fhs/cms-groq-queries';

/** CMS blocks and `@portabletext/react` serializer `value` nodes (broader `children` typing). */
type PlainTextPortableBlockInput = PortableTextBlock | PageBuilderSimpleBlockContent[number];

export function plainTextFromPortableBlock(block: PlainTextPortableBlockInput | undefined): string {
  if (!block || block._type !== 'block' || !block.children?.length) {
    return '';
  }
  return block.children
    .map(child => (child._type === 'span' ? (child.text ?? '') : ''))
    .join('')
    .trim();
}

export function plainTextFromPageBuilderSimpleBlockContent(
  blocks: PageBuilderSimpleBlockContent | undefined | null
): string {
  if (!blocks?.length) {
    return '';
  }
  return blocks.map(b => plainTextFromPortableBlock(b)).filter(Boolean).join(' ').trim();
}

export function portableBlockContainsLinks(block: PlainTextPortableBlockInput | undefined): boolean {
  if (!block || block._type !== 'block' || !block.children?.length) {
    return false;
  }
  const linkKeys = new Set(
    (block.markDefs ?? [])
      .filter(def => '_type' in def && def._type === 'pageBuilderLink')
      .map(def => def._key)
  );
  if (!linkKeys.size) {
    return false;
  }
  return block.children.some(
    child => child._type === 'span' && child.marks?.some(m => linkKeys.has(m))
  );
}
